import React, { useState } from 'react';
import { useSelector } from 'react-redux'


/*
 * https://date-fns.org/v4.1.0/docs/addDays
 * https://www.npmjs.com/package/react-datepicker
 * https://reactdatepicker.com/#example-locale-without-global-variables
 */
import DatePicker from "react-datepicker";
import { registerLocale, setDefaultLocale } from  "react-datepicker";
import subDays from "date-fns/subDays"
import format from 'date-fns/format'
import { de } from 'date-fns/locale/de';


// SemanticUI components
import { Container, List, ListItem, ListHeader, ListContent, ListIcon, ListDescription, Button } from 'semantic-ui-react';


registerLocale('de', de);
setDefaultLocale('de');


/**
 * 
 * @returns 
 */
const Max2History = (data) => {
    // local State
    const [expandList, setExpandList] = useState(false);

    if (typeof data === 'undefined' || typeof data.historyData === 'undefined' || !data.historyData || !data.historyData.length) {
        return <></>
    }


    const historyItems = data.historyData.map((item, index)=> {
        if (!expandList && index > 9) {
            return <></>;
        }

        const created_at = format(new Date(item.created_at), 'dd.MM.yyyy, HH:mm:ss');
        const operation = JSON.parse(item.operation_details);
        let icon = '';
        switch (operation.action) {
            case 'OPEN':    icon = 'folder open outline'; break;
            case 'UPDATE':  icon = 'save'; break;
            case 'CREATE':  icon = 'add'; break;
            default: icon = 'circle'; break;
        }
        return (
            <ListItem>
                <ListIcon name={icon} size='large' verticalAlign='middle' />
                <ListContent>
                    <ListHeader as='a'>{item.operation_text}</ListHeader>
                    <ListDescription as='a'>{created_at} Uhr, {item.uname}</ListDescription>
                </ListContent>
            </ListItem>
        )
    });

  
    return (
        <Container>
            <List divided relaxed>{historyItems}</List>
            {!expandList && data?.historyData.length > 10 && (<Button basic circular onClick={()=>setExpandList(true)}>mehr ...</Button>)}
            {expandList && (<Button basic circular onClick={()=>setExpandList(false)}>weniger ...</Button>)}
        </Container>
    )
}

export default Max2History;